<template>
    <page-section class="py-0">
        <template #pageSectionImmersive>
            <v-row no-gutters>
                <v-col cols="12" lg="6" :order-lg="reverse ? 2 : 1" data-aos="fade" data-aos-delay="200">
                    <v-img :max-height="$vuetify.breakpoint.lgAndUp ? 980 : 300" height="100%" :src="imageSrc" />
                </v-col>
                <v-col cols="12" lg="6" align-self="center" :order-lg="reverse ? 1 : 2">
                    <div class="d-flex align-center justify-center px-12px pt-40px pb-60px px-md-40px pt-md-40px pb-md-80px py-lg-80px">
                        <div :style="$vuetify.breakpoint.lgAndUp ? 'max-width: 588px;' : ''" data-aos="fade-up" data-aos-delay="300">
                            <v-divider class="grey darken-4" />
                            <div class="py-20px py-md-40px py-xl-80px">
                                <div class="tit-wrap tit-wrap--sm">
                                    <slot name="title" />
                                </div>
                                <div class="txt txt--xl">
                                    <slot name="text" />
                                </div>
                            </div>
                            <v-divider class="grey darken-4" />
                        </div>
                    </div>
                </v-col>
            </v-row>
        </template>
    </page-section>
</template>

<script>
import PageSection from "@/pages/client/templates/page-section.vue";

export default {
    props: {
        imageSrc: { type: String },
        reverse: { type: Boolean },
    },
    components: {
        PageSection,
    },
    data: () => {
        return {};
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init: function() {},
    },
};
</script>

<style lang="scss" scoped>

</style>
